export default __webpack_public_path__ + "static/media/026-ping pong.155c268b.svg";